import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaExternalLinkAlt, FaTimes, FaMobile, FaGlobe } from "react-icons/fa";
import {
  SiNextdotjs,
  SiReact,
  SiNodedotjs,
  SiPython,
  SiMongodb,
} from "react-icons/si";
import "./Projects.css";
import inkypen from "../../assets/InkypenWebsite.PNG";
import simulation from "../../assets/simulation.PNG";
import bookshop from "../../assets/bookshop.PNG";
import hospitalqueue from "../../assets/hospitalqueue.PNG";
import police from "../../assets/crimechecker.PNG";
import sentimental from "../../assets/sentimental.PNG";
import prs from "../../assets/prs.PNG";
import afrotale from "../../assets/afrotales.PNG";
import legaldoc from "../../assets/legalai.PNG";
import Quortek from "../../assets/quorteksite.PNG";
import shipment from "../../assets/shipment.PNG";
import quortekAI from "../../assets/quortekAI.PNG";
import votechain from "../../assets/votechain.PNG";
import bartersquare from "../../assets/bartersquare.PNG";
import { Helmet } from "react-helmet-async";

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeTab, setActiveTab] = useState("web");

  const projects = {
    web: [
      {
        image: Quortek,
        title: "Quortek",
        description:
          "Transforming business ideas into practical innovations using cutting-edge development technologies.",
        link: "https://quortek.vercel.app/",
        technologies: ["NextJs", "Tailwind", "Node.js"],
        icon: <SiNextdotjs />,
      },
      {
        image: legaldoc,
        title: "AI Legal Document Creator",
        description:
          "Effortlessly create legal documents in seconds using the power of AI.",
        link: "https://legalgeniusai.vercel.app/",
        technologies: ["NextJs", "Tailwind", "Node.js"],
        icon: <SiNextdotjs />,
      },
      {
        image: quortekAI,
        title: "Quortek AI",
        description:
          "AI-powered platform for generating business ideas and solutions.",
        link: "https://quortek-ai.vercel.app/",
        technologies: ["React", "AI", "Node.js"],
        icon: <SiReact />,
      },
      {
        image: shipment,
        title: "Vastsea Carrier",
        description:
          "Premium Delivery Service. World-class delivery solutions with speed and professionalism you can trust.",
        link: "https://vastseacarrier.vercel.app/",
        technologies: ["React", "CSS", "Node.js", "Express", "MongoDb"],
        icon: <SiReact />,
      },

      {
        image: police,
        title: "Crime Check System",
        description: "Law Enforcement Data Management",
        link: "https://npfcrimesystem.vercel.app/",
        technologies: ["React", "Node.js", "MongoDb", "ExpressJs"],
        icon: <SiReact />,
      },
      {
        image: votechain,
        title: "VoteChain",
        description:
          "Run secure, transparent contests for writing, art, fashion, talent show, school election and beauty pageants using blockchain.",
        link: "https://votes-chain.vercel.app/",
        technologies: ["Nextjs", "Solidity", "Tailwind", "Blochain"],
        icon: <SiNextdotjs />,
      },
      {
        image: bartersquare,
        title: "Barter Square",
        description: "Trade what you have, for what you need.",
        link: "https://votes-chain.vercel.app/",
        technologies: ["Nextjs", "Tailwind"],
        icon: <SiNextdotjs />,
      },

      {
        image: hospitalqueue,
        title: "Hospital Queue System",
        description:
          "Automated queue management solution for healthcare facilities.",
        link: "https://hospital-qms.netlify.app/",
        technologies: ["React", "Node.js"],
        icon: <SiReact />,
      },
      {
        image: sentimental,
        title: "Sentiment Analysis",
        description: "NLP technique to determine emotional tone in text.",
        link: "https://sentimental-analysis-app.netlify.app/",
        technologies: ["React", "Python", "NLP"],
        icon: <SiPython />,
      },
      {
        image: afrotale,
        title: "AfroTale",
        description:
          "Discover amazing African stories, poetry, and dramas in one place.",
        link: "https://afrotales.netlify.app/",
        technologies: ["React", "Node.js"],
        icon: <SiReact />,
      },
      {
        image: prs,
        title: "Recommendation System",
        description:
          "Advanced system that analyzes preferences to offer personalized suggestions.",
        link: "https://personalized-rs.netlify.app/",
        technologies: ["React", "Node.js"],
        icon: <SiReact />,
      },
      {
        image: bookshop,
        title: "MOUAU Bookshop",
        description: "Digital bookshop for Michael Okpara University students.",
        link: "https://mouau-ebookshop.netlify.app/",
        technologies: ["React", "Node.js"],
        icon: <SiReact />,
      },

      {
        image: simulation,
        title: "Queue Simulation",
        description: "Computer model for simulating queuing processes.",
        link: "https://queue-simulation-app.onrender.com",
        technologies: ["Python", "Flask", "Html", "CSS"],
        icon: <SiPython />,
      },

      {
        image: inkypen,
        title: "InkyPen",
        description: "Platform for writers and readers to connect.",
        link: "https://inkypen.netlify.app",
        technologies: ["React", "Node.js", "MongoDB"],
        icon: <SiMongodb />,
      },
    ],
    mobile: [
      {
        title: "Mobile Projects Coming Soon",
        description:
          "Currently developing innovative mobile applications - check back later!",
        technologies: ["React Native", "Flutter"],
        icon: <FaMobile />,
      },
    ],
  };

  const closeProjectDetails = () => setSelectedProject(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    window.scrollTo(0, 0);
  };

  const getTechIcon = (tech) => {
    switch (tech) {
      case "NextJs":
        return <SiNextdotjs />;
      case "React":
        return <SiReact />;
      case "Node.js":
        return <SiNodedotjs />;
      case "Python":
        return <SiPython />;
      case "MongoDB":
        return <SiMongodb />;
      default:
        return <FaGlobe />;
    }
  };

  return (
    <div>
      <Helmet>
        <title>Project - King Damian</title>
        <meta
          name="description"
          content="Check out some of my previous projects"
        />
        <meta property="og:title" content="Project - King Damian" />
        <meta
          property="og:description"
          content="Check out some of my previous projects"
        />
      </Helmet>
      <motion.div
        className="projects-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="projects-header">
          <motion.h1
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            My <span className="highlight">Projects</span>
          </motion.h1>

          <motion.p
            className="subtitle"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Transforming ideas into digital experiences through cutting-edge
            development
          </motion.p>
        </div>

        <div className="tabs-container">
          <motion.button
            className={`tab ${activeTab === "web" ? "active" : ""}`}
            onClick={() => handleTabClick("web")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaGlobe /> Web Applications
          </motion.button>
          <motion.button
            className={`tab ${activeTab === "mobile" ? "active" : ""}`}
            onClick={() => handleTabClick("mobile")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaMobile /> Mobile Applications
          </motion.button>
        </div>

        <motion.div
          className="projects-grid"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {projects[activeTab].map((project, index) => (
            <motion.div
              key={`${activeTab}-${index}`}
              className="project-card"
              whileHover={{ y: -10 }}
              transition={{ type: "spring", stiffness: 300 }}
              onClick={() => setSelectedProject(project)}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              // transition={{ delay: index * 0.05 }}
            >
              <div className="card-image-container">
                <img
                  src={project.image}
                  alt={project.title}
                  className="card-image"
                />
                <div className="card-hover-overlay">
                  <FaExternalLinkAlt className="link-icon" />
                </div>
              </div>
              <div className="card-content">
                <div className="tech-icon">
                  {project.icon || getTechIcon(project.technologies[0])}
                </div>
                <h3>{project.title}</h3>
                <div className="tech-tags">
                  {project.technologies.map((tech, idx) => (
                    <span key={idx} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <AnimatePresence>
          {selectedProject && (
            <motion.div
              className="project-modal"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <motion.div
                className="modal-content"
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.9 }}
              >
                <button className="close-button" onClick={closeProjectDetails}>
                  <FaTimes />
                </button>

                <div className="modal-image-container">
                  <img
                    src={selectedProject.image}
                    alt={selectedProject.title}
                  />
                </div>

                <div className="modal-details">
                  <h2>{selectedProject.title}</h2>
                  <p>{selectedProject.description}</p>

                  <div className="modal-tech">
                    <h4>Technologies:</h4>
                    <div className="tech-stack">
                      {selectedProject.technologies.map((tech, idx) => (
                        <div key={idx} className="tech-item">
                          {getTechIcon(tech)}
                          <span>{tech}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <a
                    href={selectedProject.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="live-button"
                  >
                    <FaExternalLinkAlt /> View Live Project
                  </a>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default Projects;
